var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _mask, _mask2, _style, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 367 298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 359.7,
    y1: 120.2,
    x2: 343.3,
    y2: 119.9,
    gradientTransform: "matrix(1 0 0 -1 0 297.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fa1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f7083"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 3.1,
    y1: 144.1,
    x2: 17.9,
    y2: 151.6,
    gradientTransform: "matrix(1 0 0 -1 0 297.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fa1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f7083"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 144.7,
    y1: 183.8,
    x2: 97.9,
    y2: 87.1,
    gradientTransform: "matrix(1 0 0 -1 0 297.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dacb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7da"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 22.2,
    y1: 186.5,
    x2: 37.2,
    y2: 178.9,
    gradientTransform: "matrix(1 0 0 -1 0 297.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fa1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f7083"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 324.2,
    y1: 88.4,
    x2: 223.3,
    y2: 66.2,
    gradientTransform: "matrix(1 0 0 -1 0 297.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dacb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7da"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 7.6,
    y1: 167.7,
    x2: 23.9,
    y2: 166.8,
    gradientTransform: "matrix(1 0 0 -1 0 297.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fa1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f7083"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 363.3,
    y1: 96.5,
    x2: 348.8,
    y2: 104.5,
    gradientTransform: "matrix(1 0 0 -1 0 297.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fa1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f7083"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 345.7,
    y1: 139.5,
    x2: 330.4,
    y2: 132.4,
    gradientTransform: "matrix(1 0 0 -1 0 297.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fa1b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f7083"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 193.7,
    y: 153.4,
    width: 129,
    height: 140.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1_852_38976"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m243.1 154 72.2 33.7c6 2.8 8.6 9.9 5.8 15.9l-38.6 82.7c-2.8 6-9.9 8.6-15.9 5.8l-72.2-33.7 4.6-9.9 12.7-10.4-1.5-13.5-.4-12.8 10.5-9 7.1-15.1 11.2-7.3-.4-15.8 4.9-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m243.1 154 72.2 33.7c6 2.8 8.6 9.9 5.8 15.9l-38.6 82.7c-2.8 6-9.9 8.6-15.9 5.8l-72.2-33.7 4.6-9.9 12.7-10.4-1.5-13.5-.4-12.8 10.5-9 7.1-15.1 11.2-7.3-.4-15.8 4.9-10.6Z"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 45.7,
    y: 105.6,
    width: 133.6,
    height: 142.6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_852_38976"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M47.3 158c-2.8-6-.2-13.1 5.8-15.9l76.8-35.8 5.1 10.8 11.6 8.6-.2 16 7.4 12.9.4 15.9 19.6 13.7.5 17.3 4.3 9.2-76.8 35.8c-6 2.8-13.1.2-15.9-5.8L47.3 158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M47.3 158c-2.8-6-.2-13.1 5.8-15.9l76.8-35.8 5.1 10.8 11.6 8.6-.2 16 7.4 12.9.4 15.9 19.6 13.7.5 17.3 4.3 9.2-76.8 35.8c-6 2.8-13.1.2-15.9-5.8L47.3 158Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0
    },
    d: "M59 0h252v233H59z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-14,.cls-17,.cls-3,.cls-6,.cls-7{stroke-width:0}.cls-17,.cls-18{fill:none}.cls-3{fill:#008a97}.cls-18{stroke:#fff}.cls-14{fill-rule:evenodd}.cls-17,.cls-6{isolation:isolate}.cls-14,.cls-6{fill:#fff}.cls-17,.cls-6{mix-blend-mode:overlay}.cls-7{fill:#49ffef}.cls-22{opacity:.6}.cls-23{opacity:.5}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 185,
    cy: 116.5,
    rx: 72.5,
    ry: 67.1,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185,
    cy: 116.5,
    rx: 126,
    ry: 116.5,
    style: {
      opacity: 0.4,
      stroke: "#686b89",
      strokeDasharray: "0 0 2 9",
      strokeWidth: 2,
      isolation: "isolate",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5 113.2c0 .7 0 1.4-.1 2 0 .7-.2 1.2-.5 1.8-.3.5-.6.9-1.1 1.2-.5.3-1.1.5-2 .5s-1.5-.2-2-.5-.9-.7-1.1-1.2c-.3-.5-.4-1.1-.5-1.8v-2l-1.7-10.6v-8c0-.9 0-1.8.2-2.7.2-.9.4-1.6.8-2.3.4-.7.9-1.2 1.6-1.6.7-.4 1.6-.6 2.7-.6s2 .2 2.7.7c.7.4 1.2 1 1.6 1.7.4.7.7 1.5.8 2.3.2.9.2 1.8.2 2.7v8l-1.6 10.5Zm1.7 14.5c0 1.9-.5 3.2-1.4 4.1-.9.9-2.3 1.3-4 1.3s-3.1-.4-4-1.3c-.9-.9-1.4-2.3-1.4-4.1s.5-3.2 1.4-4.1c.9-.8 2.3-1.3 4-1.3s3.2.4 4 1.3c.9.9 1.3 2.2 1.3 4.1Z",
    style: {
      fill: "#7277a7",
      opacity: 0.5,
      isolation: "isolate",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.3 158c-2.8-6-.2-13.1 5.8-15.9l76.8-35.8 5.1 10.8 11.6 8.6-.2 16 7.4 12.9.4 15.9 19.6 13.7.5 17.3 4.3 9.2-76.8 35.8c-6 2.8-13.1.2-15.9-5.8L47.3 158Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#linear-gradient)",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M47.3 158c-2.8-6-.2-13.1 5.8-15.9l76.8-35.8 5.1 10.8 11.6 8.6-.2 16 7.4 12.9.4 15.9 19.6 13.7.5 17.3 4.3 9.2-76.8 35.8c-6 2.8-13.1.2-15.9-5.8L47.3 158Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 104.7,
    cy: 217.9,
    rx: 10.2,
    ry: 9.4,
    transform: "rotate(-25 104.771 217.966)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 115.1,
    cy: 213,
    rx: 10.2,
    ry: 9.4,
    transform: "rotate(-25 115.067 213.15)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    transform: "rotate(-25 106.695 155.924)",
    d: "M52 146.5h109.5v18.8H52z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m243.1 154 72.2 33.7c6 2.8 8.6 9.9 5.8 15.9l-38.6 82.7c-2.8 6-9.9 8.6-15.9 5.8l-72.2-33.7 4.6-9.9 12.7-10.4-1.5-13.5-.4-12.8 10.5-9 7.1-15.1 11.2-7.3-.4-15.8 4.9-10.6Z",
    style: {
      fill: "url(#linear-gradient-2)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m243.1 154 72.2 33.7c6 2.8 8.6 9.9 5.8 15.9l-38.6 82.7c-2.8 6-9.9 8.6-15.9 5.8l-72.2-33.7 4.6-9.9 12.7-10.4-1.5-13.5-.4-12.8 10.5-9 7.1-15.1 11.2-7.3-.4-15.8 4.9-10.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-1)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    transform: "rotate(-65 269.698 205.36)",
    d: "M260.3 159.5h18.8v91.7h-18.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    transform: "rotate(-65 252.06 252.27)",
    d: "M249.1 226.8h5.9v50.9h-5.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    transform: "rotate(-65 257.962 266.733)",
    d: "M255 252.7h5.9v28H255z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m347 183.1 11.4-6.6c1.2-.7 1.6-2.3 1-3.6-.7-1.3-2.1-1.7-3.3-1l-11.4 6.6c-1.2.7-1.6 2.3-1 3.6.7 1.3 2.1 1.7 3.3 1.1Z",
    style: {
      fill: "url(#linear-gradient-3)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 168.6 7.9-11.1c.8-1.2.6-2.8-.5-3.7-1.1-.9-2.6-.7-3.4.5l-7.9 11.1c-.8 1.2-.6 2.8.5 3.7 1.1.9 2.6.6 3.4-.5Z",
    style: {
      fill: "url(#linear-gradient-4)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.6 199.4 12.9.4c1.4 0 2.5-1.1 2.5-2.6s-1.1-2.7-2.4-2.7l-12.9-.4c-1.4 0-2.5 1.1-2.5 2.6s1.1 2.7 2.4 2.7Z",
    style: {
      fill: "url(#linear-gradient-5)",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 136-11.1-7c-1.2-.7-1.5-2.3-.8-3.6.7-1.3 2.2-1.7 3.4-.9l11.1 7c1.2.7 1.5 2.3.8 3.6-.7 1.3-2.2 1.7-3.4.9Z",
    style: {
      fill: "url(#linear-gradient-6)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 122 24 110.7c-.8-1.2-.5-2.8.6-3.7 1.1-.8 2.6-.6 3.4.6l7.5 11.3c.8 1.2.5 2.8-.6 3.7-1.1.8-2.6.6-3.4-.6Z",
    style: {
      fill: "url(#linear-gradient-7)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 152.3H4c-1.4 0-2.4-1.2-2.4-2.7 0-1.5 1.1-2.6 2.5-2.6H17c1.4 0 2.4 1.2 2.4 2.7 0 1.5-1.1 2.6-2.5 2.6Z",
    style: {
      fill: "url(#linear-gradient-8)",
      strokeWidth: 0
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDeclined);
export default __webpack_public_path__ + "static/media/payment-declined.3b75fdb543bc35216b6f7baf58a4f4c1.svg";
export { ForwardRef as ReactComponent };